import { activityTypes } from "@constants/activities";

export const categorizeActivities = (
  activities,
  isPastAgenda = false,
  gracePeriodActivities = [],
  { keepCompletedInPlace = false } = {}
) => {
  const pending = [];
  const announcementsSent = [];
  const completed = [];
  const unrun = [];

  activities.forEach((activity) => {
    if (activity.type === activityTypes.share && activity.startTime) {
      // Check if Share activity is in grace period - if so, keep it in pending
      if (
        gracePeriodActivities.includes(activity._id) ||
        keepCompletedInPlace
      ) {
        pending.push(activity);
      } else {
        announcementsSent.push(activity);
      }
    } else if (activity.type !== activityTypes.share && activity.endTime) {
      // Check if activity is in grace period - if so, keep it in pending
      if (
        gracePeriodActivities.includes(activity._id) ||
        keepCompletedInPlace
      ) {
        pending.push(activity);
      } else {
        completed.push(activity);
      }
    } else if (activity.live) {
      pending.push(activity);
    } else if (activity.startTime && !activity.endTime && !activity.live) {
      if (isPastAgenda) {
        completed.push(activity);
      } else {
        pending.push(activity);
      }
    } else if (!activity.startTime && !activity.endTime && !activity.live) {
      if (isPastAgenda) {
        unrun.push(activity);
      } else {
        pending.push(activity);
      }
    }
  });

  return {
    pending,
    announcementsSent,
    completed,
    unrun,
  };
};
